import { Button } from '@/shared/ui/button'
import React from 'react'
import { ShowMoreProps } from '../show-more'
import withShowMore from './show-more.hoc'

type ComponentProps = {
  defaultVisibleItems?: ShowMoreProps['defaultVisibleItems']
} & Omit<ShowMoreProps, 'loadItemsCount' | 'renderAction'>

export default function Component(props: ComponentProps) {
  return withShowMore({
    ...props,
    loadItemsCount: 10000000000,
    defaultVisibleItems: props?.defaultVisibleItems || 1,
    renderAction: ({ isMore, isReset, noMore, more, reset }) => {
      if (noMore) return null
      const isMoreText = isMore && 'Показать все'
      const isResetText = isReset && 'Свернуть'
      return (
        <Button
          type="button"
          className="mt-2"
          variant="ghost"
          onClick={() => {
            isMore && more()
            isReset && reset()
          }}
        >
          {isMoreText || isResetText}
        </Button>
      )
    },
  })
}
